<svg:g xmlns:svg="http://www.w3.org/2000/svg" class="gauge">
    <!-- Track (full sweep, muted) under the value fill (accent). -->
    <svg:path [attr.d]="trackPath" fill="currentColor" fill-opacity="0.12"></svg:path>
    <svg:path *ngIf="fillPath" [attr.d]="fillPath" [attr.fill]="config.colors[0]" fill-opacity="0.9"></svg:path>

    <!-- Target: a tick across the band with its value floated just outside it. -->
    <svg:g *ngIf="targetTick">
        <svg:line [attr.x1]="targetTick.x1" [attr.y1]="targetTick.y1"
                  [attr.x2]="targetTick.x2" [attr.y2]="targetTick.y2"
                  stroke="currentColor" stroke-opacity="0.75" stroke-width="2"></svg:line>
        <svg:text [attr.x]="targetTick.lx" [attr.y]="targetTick.ly"
                  [attr.text-anchor]="targetTick.anchor" dy="0.32em"
                  fill="currentColor" fill-opacity="0.7" font-size="11">{{targetText}}</svg:text>
    </svg:g>

    <!-- The number is the message: value writ large in the arc's mouth, unit under it. -->
    <svg:text [attr.x]="cx" [attr.y]="cy - 14" text-anchor="middle"
              fill="currentColor" fill-opacity="0.92"
              font-size="30" font-weight="600">{{valueText}}</svg:text>
    <svg:text *ngIf="unitText" [attr.x]="cx" [attr.y]="cy + 8" text-anchor="middle"
              fill="currentColor" fill-opacity="0.6" font-size="11">{{unitText}}</svg:text>

    <!-- Scale ends, under the arc tips. -->
    <svg:text [attr.x]="cx - (rOuter + rInner) / 2" [attr.y]="cy + 18" text-anchor="middle"
              fill="currentColor" fill-opacity="0.6" font-size="11">{{minText}}</svg:text>
    <svg:text [attr.x]="cx + (rOuter + rInner) / 2" [attr.y]="cy + 18" text-anchor="middle"
              fill="currentColor" fill-opacity="0.6" font-size="11">{{maxText}}</svg:text>
</svg:g>
